import { Capacitor } from "@capacitor/core";
import { useFcmPushNotifications } from "./useFcmPushNotifications";
import { useVapidPushNotifications } from "./useVapidPushNotifications";
import type { UsePushNotificationsResult } from "./usePushNotifications.types";

export type {
  NormalizedPushSubscription,
  UsePushNotificationsResult,
} from "./usePushNotifications.types";

export const usePushNotifications = (): UsePushNotificationsResult => {
  // Both hooks are always invoked to keep hook order stable, but only the
  // platform-matching result is returned. `Capacitor.isNativePlatform()` is
  // constant for the lifetime of the app, so this branch never flips at runtime.
  const native = useFcmPushNotifications();
  const web = useVapidPushNotifications();
  return Capacitor.isNativePlatform() ? native : web;
};
